import { createContext, useContext, useEffect, useState } from 'react'
import messageReader from 'api/messageReader/get'

interface ReaderMessageContextProps {
  unReadMessages: number
  updateUnReadMessages(count: number): void
  markAsRead(count: number): void
}

export const ReaderMessageContext = createContext<ReaderMessageContextProps>(
  Object.create(null)
)

export const useReaderMessage = () => useContext(ReaderMessageContext)

interface ReaderProviderProps {
  children: React.ReactNode
  initialUnReadMessages?: number
}

export const ReaderMessageProvider: React.FC<ReaderProviderProps> = ({
  children,
  initialUnReadMessages = 0,
}) => {
  const [unReadMessages, setUnReadMessages] = useState<number>(
    initialUnReadMessages
  )

  useEffect(() => {
    const getMessageReader = async () => {
      try {
        const response = await messageReader()
        setUnReadMessages(response)
      } catch (error) {
        console.error('Error reader messages:', error)
      }
    }
    getMessageReader()
  }, [])

  const updateUnReadMessages = (count: number) => {
    setUnReadMessages(count)
  }

  const markAsRead = (count: number) => {
    setUnReadMessages((prev) => Math.max(prev - count, 0))
  }

  return (
    <ReaderMessageContext.Provider
      value={{
        unReadMessages,
        updateUnReadMessages,
        markAsRead,
      }}
    >
      {children}
    </ReaderMessageContext.Provider>
  )
}
